import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'

// 获取所有资讯
export const getarticleList = params => {
    return get("/admin/information?type=4", params);
};
// 新增资讯
export const addArticle = params => {
    return post("/admin/information", params);
};
// 修改资讯信息
export const editArticle = params => {
    return put(`/admin/information/${params.id}`, params);
};
// 删除资讯
export const deleteCity = params => {
    return del(`/admin/information/${params}`);
};
// 获取标签
export const tagSeleList = params => {
    return get("/admin/tag/script", params);
};


// WEBPACK FOOTER //
// ./src/api/script.js